import { notification } from 'antd';
import type { IconType, NotificationPlacement } from 'antd/es/notification';

type Params = {
	type: IconType;
	title: string;
	description?: React.ReactNode;
	duration?: number;
	placement?: NotificationPlacement;
};

export const openNotification = ({ type, title: message, description, duration = 7, placement = 'topRight' }: Params) => {
	notification.open({ type, message, description, duration, placement });
};
